import { Apis } from "../../lib/Apis";

export const useBrandHook = () => {
  const addBrand = async (data) => {
    try {
      const response = await Apis.addBrand(data);
      return response?.data;
    } catch (error) {
      throw new Error(
        error?.response?.data?.message || error?.message || "Failed to add brand",
      );
    }
  };

  const getBrands = async (setBrands) => {
    try {
      const response = await Apis.getBrands();
      const brands = response?.data?.data?.brands || [];
      if (setBrands) {
        setBrands(brands);
      }
      return response?.data;
    } catch (error) {
      throw new Error(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to fetch brands",
      );
    }
  };

  const updateBrand = async (brandId, data) => {
    try {
      const response = await Apis.updateBrand(brandId, data);
      return response?.data;
    } catch (error) {
      throw new Error(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to update brand",
      );
    }
  };

  const deleteBrand = async (brandId) => {
    try {
      const response = await Apis.deleteBrand(brandId);
      return response?.data;
    } catch (error) {
      throw new Error(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to delete brand",
      );
    }
  };

  return {
    addBrand,
    getBrands,
    updateBrand,
    deleteBrand,
  };
};